import Api from "@/utils/axiosApi/babyFeedingApi";

export default {
  data() {
    return {
      pageSize: 20, //当前条数
      pageNum: 1, //当前页
      total: 0, //总数
      loading: false,
      finished: false,
      recipesList: [], // 数据列表
      showEmpty: false, //无数据
      //用户信息
      userInfo: JSON.parse(localStorage.getItem("userInfo"))
    };
  },
  methods: {
    getBabyFeedList(data) {
      const obj = {
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        crmId: this.userInfo ? this.userInfo.crm_id : "",
        ...data
      };
      console.log(data, '-------------------------------')
      Api.feedList(obj, res => {
        if (res.code == "200") {
          if (this.pageNum == 1 && res.data.pageNum == 1) {
            this.recipesList = res.data.data;
          } else {
            this.recipesList = [...this.recipesList, ...res.data.data];
          }
          if (!res.data.data.length) {
            this.showEmpty = true;
          } else {
            this.showEmpty = false;
          }
          this.total = res.data.total;
          // 加载状态结束
          this.loading = false;

          if (this.recipesList.length >= this.total) {
            this.finished = true;
          } else {
            this.finished = false;
          }
        } else {
          this.showEmpty = true;
          this.finished = true;
        }
        console.log(this.recipesList.length, this.total, this.finished, '613613613')
      });
    },
    // 搜索结果页列表
    getSearchFeedRecipes(data) {
      const obj = {
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        crmId: this.userInfo ? this.userInfo.crm_id : "",
        ...data
      };
      Api.searchFeedRecipes(obj, res => {
        if (res.code == "200") {
          if (this.pageNum == 1) {
            this.recipesList = res.data.data;
          } else {
            this.recipesList = [...this.recipesList, ...res.data.data];
          }
          if (!res.data.data.length) {
            this.showEmpty = true;
          } else {
            this.showEmpty = false;
          }
          this.total = res.data.total;
        } else {
          this.showEmpty = true;
        }
        this.loading = true;
        this.finished = true;
        console.log(res);
      });
    }
  },
  watch: {
    // recipesList: {
    //   handler(newValue) {
    //     newValue.length ? (this.showEmpty = false) : (this.showEmpty = true);
    //   },
    //   deep: true,
    //   immediate: true
    // }
  }
};
